import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

export const AwsLambdaNotifierComponents = InstallSpec({
  base: ItemComponent({
    label: "AWS Lambda notifier",
    type: "generated",
    hidden: true,
    maturity: "ga",
    schema: {},
  }),
  notify: ItemComponent({
    label: "AWS Lambda",
    description:
      "Respond to notification events from P0 from an AWS Lambda function.",
    type: "string",
    maturity: "ga",
    schema: {
      functionCaller: Element({
        label: "Function caller",
        description: "The function to call to invoke the Lambda function.",
        type: "dynamic",
      }),
    },
  }),
});
